import * as React from 'react';
import {HazmatClassification, HazmatViewData, InventoryConfiguration, InventoryInfo} from './ItemMasterInterfaces';

export interface SkuDetailsProps {
  inventoryInfo: InventoryInfo;
  altIdPresence: boolean;
  serial_number_program_enabled: boolean;
  serial_number_program: string;
  inventory_configuration: InventoryConfiguration;
  hazmat_enabled: boolean;
  hazmat_viewdata: HazmatViewData;
  hazmat_classification: HazmatClassification;
  enable_item_storage_class: boolean;
  vas_receive_workflow: boolean;
  inventory_control_user: boolean;
  fai_receive_workflow: boolean;
}

const SkuDetails: React.FC<SkuDetailsProps> = (props: SkuDetailsProps) => {
  return (
    <div className="item-master-tile">
      <div className="col">
        <div className="header">
          <b>SKU Details</b>
        </div>
        <SkuDetailItem
          label="Alternate ID:"
          value={props.inventoryInfo.alternate_id}
          is_visible={props.altIdPresence}
        />
        <SkuDetailItem
          label="HS Code:"
          value={props.inventoryInfo.hs_code}
          is_visible={!!props.inventoryInfo.hs_code}
        />
        <SkuDetailItem
          label="Country of Origin:"
          value={props.inventoryInfo.country_of_origin}
          is_visible={!!props.inventoryInfo.country_of_origin}
        />
        <SkuDetailItem
          label="Serial Number Program:"
          value={props.serial_number_program || 'None'}
          is_visible={props.serial_number_program_enabled}
        />
        {props.inventory_configuration && (
          <div>
            <SkuDetailItem
              label="Lot Code Tracking:"
              value={props.inventory_configuration.lot_code_tracking_enabled ? 'Yes' : 'No'}
              is_visible={true}
            />
            <SkuDetailItem
              label="Expiration Date Tracking:"
              value={props.inventory_configuration.expiry_date_tracking_enabled ? 'Yes' : 'No'}
              is_visible={true}
            />
          </div>
        )}
        <SkuDetailItem
          label="Hazmat Classification:"
          value={props.hazmat_viewdata.is_hazmat ? 'Yes' : 'No'}
          is_visible={props.hazmat_enabled}
        />
        <SkuDetailItem
          label="Limited Quantity:"
          value={props.hazmat_viewdata.is_ormd ? 'Yes' : 'No'}
          is_visible={props.hazmat_enabled}
        />
        {props.hazmat_classification && (
          <div>
            <SkuDetailItem
              label="UN Number:"
              value={props.hazmat_classification.un_number}
              is_visible={!!props.hazmat_classification.un_number}
            />
            <SkuDetailItem
              label="Package Code:"
              value={props.hazmat_classification.pkg_code}
              is_visible={!!props.hazmat_classification.pkg_code}
            />
          </div>
        )}
        <SkuDetailItem
          label="Group:"
          value={props.inventoryInfo.inventory_group}
          is_visible={!!props.inventoryInfo.inventory_group}
        />
        <SkuDetailItem
          label="Status:"
          value={props.inventoryInfo.txn_state.charAt(0).toUpperCase() + props.inventoryInfo.txn_state.slice(1)}
          is_visible={true}
        />
        <SkuDetailItem
          label="Shelf Life Threshold:"
          value={props.inventoryInfo.shelf_life_threshold ? props.inventoryInfo.shelf_life_threshold.toString() : '--'}
          is_visible={props.inventory_configuration && props.inventory_configuration.expiry_date_tracking_enabled}
        />
        <SkuDetailItem
          label="Temperature:"
          value={props.inventoryInfo.temperature ? props.inventoryInfo.temperature : 'Ambient'}
          is_visible={props.enable_item_storage_class}
        />
        <SkuDetailItem
          label="Allergens:"
          value={props.inventoryInfo.allergens ? props.inventoryInfo.allergens.join(', ') : 'None'}
          is_visible={props.enable_item_storage_class}
        />
        {props.inventoryInfo.csa && (
          <div>
            {Object.keys(props.inventoryInfo.csa).map((key, i) => (
              <SkuDetailItem
                key={i}
                label={`${key.charAt(0).toUpperCase() + key.slice(1)}:`}
                value={props.inventoryInfo.csa[key] ? props.inventoryInfo.csa[key] : '--'}
                is_visible={true}
              />
            ))}
          </div>
        )}
        <SkuDetailItem
          label="Bag and Tape:"
          value={props.inventory_configuration && props.inventory_configuration.bag_and_tape_required ? 'Yes' : 'No'}
          is_visible={props.vas_receive_workflow}
        />
      </div>
    </div>
  );
};

export interface SkuDetailItemProps {
  label: string;
  value: string;
  is_visible: boolean;
}

const SkuDetailItem: React.FC<SkuDetailItemProps> = (props: SkuDetailItemProps) => {
  if (!props.is_visible) return <div></div>;

  return (
    <div className="row">
      <div className="col-sm-6 tile-line-item">
        <b>{props.label}</b>
      </div>
      <div className="col-sm-6 tile-line-item text-right">{props.value}</div>
    </div>
  );
};

export default SkuDetails;
